<template>
  <div class="center paddingbottom50">
    <div class="titleNav">
      <van-row type="flex" justify="center">
        <van-col span="24" class=" textCenter">
          <div style="margin: 5% auto;height:62px;width:62px;">
            <div class=""
              style="height:62px;width:62px;border-radius:62px;position: relative;border-radius: 62px;overflow: hidden;">
              <img :src="personalInfor.avatar ? 'http://img.jiarixiaodui.com/' + personalInfor.avatar : defaultAvatar"
                style="width: 100%;height: 100%;object-fit: cover;">
              <input
                style="height:62px;width:62px;border-radius:62px;text-align: center;position: absolute;left: 0;bottom: 0;opacity: 0;"
                type="file" @change="getFile" ref="file" id="file" />
            </div>
          </div>
          <div class="cardTitle" style="margin-top: 10px;">{{ personalInfor.name ? personalInfor.name : '佚名' }}</div>
        </van-col>
      </van-row>
    </div>
    <van-cell clickable is-link v-for="(item, index) in menu" :key="index" @click="navToDetail(item.path)"
      :icon="item.icon" :title="item.title"></van-cell>
    <!-- 底部tab -->
    <myFoot></myFoot>
    <!-- 返回顶部 -->
    <backTop ref="bt"></backTop>
  </div>
</template>

<script>

export default {
  created () {
    if (localStorage.info) {
      this.personalInfor = JSON.parse(localStorage.info)
    } else {
      this.loadData()
    }
    this.wxShare()
  },
  data () {
    return {
      createFlag: false,
      personalInfor: {},
      defaultAvatar: this.$mAssetsPath.defaultAvatar,
      menu: [
        {
          title: '项目踩点',
          icon: this.$mAssetsPath.kefu,
          path: '/footprinting',
        },
        {
          title: '积分明细',
          icon: 'gem-o',
          path: '/integral',
        },
        {
          title: '我的收藏',
          icon: 'like',
          path: '/subPackages/myCenter/myFavor',
        },
        {
          title: '考试',
          icon: this.$mAssetsPath.exam,
          path: '/subPackages/myCenter/examList',
        },
        {
          title: '我的近照',
          icon: this.$mAssetsPath.centerPersonalPhoto,
          path: '/subPackages/myCenter/personalPhoto',
        },
        {
          title: '课程资料',
          icon: this.$mAssetsPath.videodetail,
          path: '/subPackages/myCenter/file?types=视频资料',
        },
        {
          title: '异常信息',
          icon: this.$mAssetsPath.chooseCity,
          path: '/abnormal',
        },
        {
          title: '个人信息',
          icon: this.$mAssetsPath.centerPersonInfor,
          path: '/subPackages/myCenter/personInfor',
        },
        // {
        // 	title:'城市切换',
        // 	icon:this.$mAssetsPath.chooseCity,
        // 	path:'/subPackages/myCenter/chooseCity',
        // },
        {
          title: '个人经历',
          icon: this.$mAssetsPath.centerPersonalExperience,
          path: '/subPackages/myCenter/personalExperience',
        },
        {
          title: '银行账户',
          icon: this.$mAssetsPath.centerBankAccount,
          path: '/subPackages/myCenter/bank',
        },
        {
          title: '薪资查询',
          icon: this.$mAssetsPath.centerCheckMoney,
          path: '/subPackages/myCenter/searchMoney',
        },

        {
          title: '帮助反馈',
          icon: this.$mAssetsPath.help,
          path: '/subPackages/myCenter/helpCenter',
        },
        {
          title: '注销',
          icon: this.$mAssetsPath.centerLoginOut,
          path: 'zhuxiao',
        },
      ],
    }
  },
  methods: {
    navToDetail (path) {
      const that = this
      if (path == 'zhuxiao') {
        this.$dialog
          .confirm({
            title: '提示',
            message: '确认注销吗',
          })
          .then(() => {
            this.$store.commit('SET_LOGOUT')
            this.$router.replace({ path: '/' })
            // window.location.reload()
          })
      } else if (path == '/subPackages/myCenter/chooseCity') {
        this.changeStoreSite()
        this.$router.push({
          path: '/subPackages/myCenter/chooseCity',
        })
      } else {
        this.$router.push({
          path: path,
        })
      }
    },
    changeStoreSite () {
      try {
        this.$axios.get('user/info').then((res) => {
          let data = res.data
          if (data.code == 200) {
            this.city = data.data.site
            this.$store.commit('ChangeSite', this.city)
          }
        })
      } catch (e) {
        if (this.$mConfig.debug) {
          console.log(e)
        }
      }
    },
    getFile (e) {
      let _this = this
      var files = e.target.files[0]
      if (!e || !window.FileReader) return // 看支持不支持FileReader
      let reader = new FileReader()
      reader.readAsDataURL(files) // 这里是最关键的一步，转换就在这里
      reader.onloadend = function () {
        lrz(this.result, { width: 300, height: 300, quality: 0.6 })
          .then(function (rst) {
            _this.$toast.loading({
              duration: 0, // 持续展示 toast
              forbidClick: true, // 禁用背景点击
              loadingType: 'spinner',
              mask: true,
              message: '图片上传中',
            })
            try {
              _this.$axios
                .post('user/avatar', { file: rst.base64 })
                .then((res) => {
                  if (res.data.code == 200) {
                    _this.$toast.clear()
                    _this.personalInfor.avatar = res.data.data.image
                    _this.$toast(res.data.msg)
                  } else {
                    _this.$toast(res.data.msg)
                  }
                  _this.$toast.clear()
                })
            } catch (e) {
              console.log(e)
            }
          })
          .catch(function (err) {
            console.log(err)
          })
      }
    },
    loadData () {
      try {
        this.$axios.get('user/info').then((res) => {
          if (res.data.code == 200) {
            this.personalInfor = res.data.data
            this.$store.commit('SetInfo', JSON.stringify(res.data.data))
          }
        })
      } catch (e) {
        if (this.$mConfig.debug) {
          console.log(e)
        }
      }
    },
  },
}
</script>

<style scoped="scoped">
.titleNav {
  background: url('../../assets/static/img/my-bg.png') no-repeat;
  background-size: 100% 150px;
  height: 150px;
  text-align: center;
}
</style>
